import { render, staticRenderFns } from "./backer.vue?vue&type=template&id=3472ff2e&scoped=true&"
import script from "./backer.vue?vue&type=script&lang=js&"
export * from "./backer.vue?vue&type=script&lang=js&"
import style0 from "./backer.vue?vue&type=style&index=0&id=3472ff2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3472ff2e",
  null
  
)

export default component.exports